import React, { useEffect, useState } from 'react';

const Thumbnail = ({ file, source, className, placeHolderImage, style }) => {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [thumb, setThumb] = useState(undefined);
  let imageHolder = null;

  useEffect(() => {
    if (!file) {
      return;
    }

    setLoading(true);
    const reader = new FileReader();

    reader.onloadend = () => {
      setLoading(false);
      setThumb(reader.result);
    };

    reader.readAsDataURL(file);
  }, [file]);

  if (source) {
    imageHolder = <img src={source} style={style} className={className} alt="" />;
  }

  if (!file && !source) {
    imageHolder = <img src={placeHolderImage} style={style} alt="placeholder" className={className} title="Please select a picture" />;
  }

  if (thumb) {
    imageHolder = <img src={thumb} style={style} className={className} alt="avatar" title="Click to change" />;
  }

  return imageHolder;
};

export default Thumbnail;
